import React, { useState } from "react";
import { Card, CardBody, CardHeader, Button, Row, Col } from "reactstrap";
import { FaUser, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaIdCard } from 'react-icons/fa';
import UpdatePassword from "./updatePassword";

const MyInfo = ({ user }) => {
  const [activeTab, setActiveTab] = useState("Mes informations");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      {tabs.map((tab) => (
        <Button
          key={tab}
          onClick={() => handleTabChange(tab)}
          className={`btn ${activeTab === tab ? "active-tab" : "btn-light"}`}
        >
          {tab}
        </Button>
      ))}
    </div>
  );

  const tabs = ["Mes informations", "Gestion de mot de passe", "Autres"];

  return (
    <Card id="contactList">
      <CardHeader>{renderTabs()}</CardHeader>
      <CardBody className="pt-0">
        {activeTab === "Mes informations" && (
          <div>
            <br/>
            <Row className="mb-3">
              <Col md={4}>
                <FaUser /> Nom d'utilisateur
              </Col>
              <Col md={8} >
                <p>{user?.username || "-"}</p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <FaEnvelope /> Email 
              </Col>
              <Col md={8} >
                <p>{user?.email || "-"}</p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <FaPhoneAlt /> Téléphone 
              </Col>
              <Col md={8} >
                <p>{user?.phone || "-"}</p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <FaMapMarkerAlt /> Adresse 
              </Col>
              <Col md={8} >
                <p>{user?.address || "-"}</p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <FaIdCard /> Numéro de CNI 
              </Col>
              <Col md={8} >
                <p>{user?.cniNumber || "-"}</p>
              </Col>
            </Row>
          </div>
        )}

        {activeTab === "Gestion de mot de passe" && <UpdatePassword />}
        {activeTab === "Autres" && (
          <div className="d-flex flex-column align-items-center text-center p-3">
            <h5 className="mb-3">Besoin d'aide ou d'autres informations ?</h5>
            <p className="mb-3 text-muted">
              Vous pouvez contacter notre support pour toute question ou demande supplémentaire.
            </p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default MyInfo;
